import React, { Component } from 'react'
import styles from "./DownloadProPage.module.css"
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
// api
import FireBaseFunc from "../util/FirebaseService/FirebaseFunc"
import PaySubBtn from "../util/PaypalApi/PaySubBtn"
import YouTube from 'react-youtube';

export default class DownloadProPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            user: null,
            compareList: [
                ["", ["Free", "Premium"]],
                ["Moving image", ["V", "V"]],
                ["Scale", ["V", "V"]],
                ["Crop", ["V", "V"]],
                ["Adjust Opacity", ["V", "V"]],
                ["Hidden", ["V", "V"]],
                ["Download", ["V", "V"]],
                ["Search", ["At least 5 sec delay", "V"]],
                ["Multi-Shoot", ["3 limitation", "V"]],
                ["Get shoot from other tabs", ["X", "V"]],
            ]
        }
    }

    // Handler
    getUserStatusHandler = (e) => {
        FireBaseFunc.getUserDoc(this.state.user).
            then(res => { console.log(res) })
    }
    // component
    VideoDespComponent = () => {
        const opts = {
            height: '720',
            width: '1280',
            playerVars: {
                // https://developers.google.com/youtube/player_parameters
                loop: 1
            },
        };

        return (
            <div>
                <YouTube videoId={process.env.REACT_APP_HOME_VID_ID} opts={opts} />
            </div>
        )
    }

    paypalOnError = (err) => { console.log("Error") }
    paypalOnApprove = (data, detail) => {
        // call the backend api to store transaction details
        console.log("Payapl approved", data.subscriptionID, this.state.user)
        FireBaseFunc.updateUserDoc(this.state.user, { status: "Payment" })
    };
    paypalBtn = () => {
        var comp = []

        comp.push(<PaySubBtn
            onApprove={this.paypalOnApprove}
            catchError={this.paypalOnError}
            onError={this.paypalOnError}
            onCancel={this.paypalOnError} />)

        if (this.state.user == null) {
            comp.push(<Link to="/loginBeforePayment" className={styles.payBtnSignInBlockStyle}></Link>)
        }

        return (<div className={styles.paybtnWrapper}>{comp}</div>)
    }

    componentDidMount() {
        FireBaseFunc.getStateChange((user) => {
            this.setState(state => { return { user: user } })
        })
    }

    render() {
        return (
            <div className={styles.container}>
                <div className={styles.compareListWrapper}>
                    {this.VideoDespComponent()}
                    <div className={styles.dollarStyle}>$<span>1.5</span> / Month</div>
                    {this.paypalBtn()}
                </div>
            </div>
        )
    }
}
